import React, { useState } from "react";
import Styles from "./SelfListing.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveListingId,
  fetchDocumentUrlByLedgerId,
} from "../../../../Redux/Slices/bankingSlice";
import { ReactComponent as Chat } from "../../../../assets/images/Chat_white.svg";
import { ReactComponent as Download } from "../../../../assets/images/Download_white.svg";
import { ReactComponent as Duplicate } from "../../../../assets/images/Duplicate_white.svg";
import { ReactComponent as Edit } from "../../../../assets/images/Edit_white.svg";
import { ReactComponent as Request } from "../../../../assets/images/Request_white.svg";
import { ReactComponent as UpArrow } from "../../../../assets/images/arrowUp.svg";
import { ReactComponent as EditInactiveIcon } from "../../../../assets/images/edit_grey.svg";
import { ReactComponent as RequestInactiveIcon } from "../../../../assets/images/request_grey.svg";
import { ReactComponent as ChatInactiveIcon } from "../../../../assets/images/Chat_grey.svg";
import { ReactComponent as DownloadInactiveIcon } from "../../../../assets/images/download_gray.svg";
import { ReactComponent as DuplicateInactiveIcon } from "../../../../assets/images/duplicate_gray.svg";
import { ReactComponent as UpArrowColor } from "../../../../assets/images/UpArrowColor.svg";
import { useNavigate } from "react-router-dom";
import Countdown from "../../../../commons/CountDownTimer/Countdown";
import { resetListingStatus } from "../../../../Redux/Slices/buySellhasApprovedAndPending";
import { getCommonChatDetails } from "../../../../Services/Chat/Chat";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../commons/Toast/ErrorMessage";
import CombinedChatModal from "../../../ChatApplication/CombinedChatModal/CombinedChatModal";
import { downloadListing } from "../../../../Services/ApiCalling/banking";
import { toast } from "react-toastify";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";

const SelfListingBox = ({
  item,
  contractId: contractIdProp = null,
  contractIdLoading = false,
  activeListingId,
  handleOpenIndent,
  setCreateEditModal,
  onDuplicateClick,
  alterButton,
  onEditClick,
  isInConnectModal = false,
  isCounterparty,
  termsFile,
  termsDocumentId,
  onViewFile,
  selfName,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [chatList, setChatList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [previewDocumentId, setPreviewDocumentId] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const activeListing = useSelector(
    (state) => state.bankingSlice?.activeLedgerData[0]?.selfListing,
  );

  // Contract ID (connectionUniqueId) for this self-listing. The plain banking
  // listing object usually doesn't carry connection info, so for the active
  // listing we source it from the matchmaking results (same data the Available
  // Listing panel uses) so both sides show the same Contract ID.
  const matchmakingMatches = useSelector(
    (state) => state.bankingSlice?.matchmakingData?.matches,
  );
  const matchmakingSelfListingId = useSelector(
    (state) => state.bankingSlice?.matchmakingData?.selfListing?.id,
  );

  const handleUpdateActiveListing = (id) => {
    if (!activeListingId) {
      dispatch(resetListingStatus());
      dispatch(setActiveListingId(id));
    }
  };

  const handleReceiveNav = (id, name, status) => {
    let routePath = "/banking_active";

    if (status === "TERMS_ACCEPTED") {
      routePath = "/banking_active";
    } else if (status === "COMPLETED") {
      routePath = "/banking_active";
    }

    navigate(`${routePath}?id=${id}`, {
      state: { listingName: name, listingId: id },
    });
  };

  const handleChat = async () => {
    let res = await getCommonChatDetails({ name: item.name });
    if (res?.data?.length > 0) {
      setChatList(res?.data);
    } else {
      ErrorMessage("The chat was not established for this listing.");
    }
  };

  const handleEditClick = () => {
    dispatch(setActiveListingId(item.id));
    setCreateEditModal(true);
  };

  const transformTimeForUI = (timeStr) => {
    return timeStr === "23:59" ? "24:00" : timeStr;
  };

  const [hovered, setHovered] = useState(false);

  const isTermsExpired = item.isTermsExpired;
  const shouldShowCountdown = isTermsExpired;

  const getBufferEndTime = () => {
    if (item.remainingTime) {
      const [datePart, timePart] = item.remainingTime.split(" ");
      const [day, month, year] = datePart.split("-");
      const [hours, minutes] = timePart.split(":");

      const bufferDate = new Date(
        `${month} ${day}, ${year} ${hours}:${minutes}`,
      );
      return bufferDate.toISOString();
    }

    if (!item.termsExpiryAt) return null;

    const [datePart, timePart] = item.termsExpiryAt.split(" ");
    const [day, month, year] = datePart.split("-");
    const [hours, minutes] = timePart.split(":");

    const termsExpiryDate = new Date(
      `${month} ${day}, ${year} ${hours}:${minutes}`,
    );

    const bufferEndDate = new Date(
      termsExpiryDate.getTime() + 2 * 60 * 60 * 1000,
    );

    return bufferEndDate.toISOString();
  };

  const bufferEndTime = getBufferEndTime();

  // ACCEPTED is surfaced as ONGOING for now — the accepted state is hidden from
  // the UI while the documentation step is bypassed.
  // const displayStatus =
  //   item.status === "TERMS_ACCEPTED" ? "ACCEPTED" : item.status;
  const displayStatus =
    item.status === "TERMS_ACCEPTED" ? "ONGOING" : item.status;

  const isBankingRoute = window.location.pathname === "/banking";

  // Direct connection info that may exist on the listing object itself.
  const ownContractId =
    item?.connectionUniqueId ||
    item?.connectionDetails?.[0]?.connectionUniqueId ||
    item?.counterPartyListings?.[0]?.connectionUniqueId ||
    null;

  // For the listing whose matchmaking results are currently loaded, reuse the
  // Contract ID from those matches so the self-listing shows the same value as
  // the Available Listing card.
  const matchmakingContractId =
    matchmakingSelfListingId === item?.id
      ? (matchmakingMatches || [])
          .map(
            (m) =>
              m?.connectionUniqueId ||
              m?.connectionDetails?.[0]?.connectionUniqueId ||
              m?.counterPartyListings?.[0]?.connectionUniqueId,
          )
          .find(Boolean) || null
      : null;

  // Fallback order: connection info on the listing itself → matchmaking (active
  // listing) → the connections-list lookup passed from the parent (covers every
  // accepted/ongoing listing, active or not).
  const contractId = ownContractId || matchmakingContractId || contractIdProp;
  // The Contract ID is only meaningful once terms are accepted or the contract
  // is ongoing/completed; hide it for earlier statuses (e.g. ACTIVE, HOLD).
  const hasContractId =
    item?.status === "TERMS_ACCEPTED" ||
    item?.status === "ONGOING" ||
    item?.status === "COMPLETED";
  const showContractId = isBankingRoute && hasContractId && contractId;
  const idLabel = "UID:";
  // While the connections list is still loading (a slower second fetch than the
  // one that renders these cards), show a placeholder in the Contract ID slot so
  // it doesn't pop in later or shift the layout.
  const showContractIdPlaceholder =
    isBankingRoute && hasContractId && !contractId && contractIdLoading;

  const statusClass =
    // TERMS_ACCEPTED now displays as ONGOING, so it takes the ongoing styling.
    // item.status === "TERMS_ACCEPTED"
    //   ? Styles.acceptedStatus
    item.status === "TERMS_ACCEPTED"
      ? Styles.ongoing
      : item.status === "ACTIVE"
        ? Styles.active
        : item.status === "HOLD"
          ? Styles.hold
          : item.status === "ONGOING" || item.status === "COMPLETED"
            ? Styles.ongoing
            : "";

  const statusDotClass =
    // item.status === "TERMS_ACCEPTED"
    //   ? Styles.acceptedDot
    item.status === "TERMS_ACCEPTED"
      ? Styles.ongoingDot
      : item.status === "ACTIVE"
        ? Styles.activeDot
        : item.status === "HOLD"
          ? Styles.holdDot
          : item.status === "ONGOING" || item.status === "COMPLETED"
            ? Styles.ongoingDot
            : "";

  const handleViewDocument = async (docId) => {
    if (!docId) {
      return;
    }

    try {
      const resultAction = await dispatch(fetchDocumentUrlByLedgerId(docId));
      if (fetchDocumentUrlByLedgerId.fulfilled.match(resultAction)) {
        const url = resultAction.payload?.url || resultAction.payload;
        if (url) {
          setPreviewFileUrl(url);
          setPreviewDocumentId(docId);
          setPreviewOpen(true);
        } else {
        }
      } else {
      }
    } catch (error) {}
  };

  const handleViewDocumentClick = (e) => {
    e.stopPropagation();
    const docId = termsDocumentId || item?.termsDocumentId;
    if (docId) {
      handleViewDocument(docId);
    }
  };

  const handleDownload = async () => {
    setDownloadLoading(true);
    try {
      const response = await downloadListing(item.id);
      const blob = response.data;
      if (!blob) return;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/pdf",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `listing_${item.name}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      SuccessMessage("Listing downloaded successfully!");
    } catch (error) {
      ErrorMessage(
        error?.response?.data?.message || "Failed to download listing.",
      );
    }
    setDownloadLoading(false);
  };

  return (
    <>
      <PreviewModal
        open={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setPreviewFileUrl(null);
          setPreviewDocumentId(null);
        }}
        fileUrl={previewFileUrl}
        documentId={previewDocumentId}
      />
      {chatList?.length > 0 && (
        <CombinedChatModal
          open={chatList?.length > 0}
          handleClose={() => setChatList([])}
          data={chatList}
          selfName={selfName || activeListing?.name}
        />
      )}
      <div
        key={item.id}
        onClick={() => {
          if (!isInConnectModal) {
            handleUpdateActiveListing(item.id);
          }
        }}
        // onClick={() => handleUpdateActiveListing(item.id)}
        className={`display_flex_column ${Styles.selfListingContainer} ${
          activeListingId ? Styles.activeListing : Styles.inactiveListing
        }`}
      >
        {/* Header */}

        <div className={`display_flex_row ${Styles.selfListingHeader}`}>
          {isInConnectModal ? (
            <>
              <div className={Styles.selfListingHeaderLeft}>
                <div
                  className={
                    `${Styles.listingMy} ` +
                    (isCounterparty
                      ? Styles.counterpartyListing
                      : Styles.myListing)
                  }
                >
                  {isCounterparty ? "Counterparty Listing" : "My Listing"}
                </div>
                <div className={Styles.listingExpiry}>
                  <span className={`${Styles.listingHead}`}>{item.name}</span>
                </div>
              </div>
              <div className={Styles.selfListingHeaderLeft}>
                <div className={` ${Styles.expiresLeft}`}>
                  {shouldShowCountdown ? "Remaining Time" : "Expires On"}
                </div>
                <div className={Styles.listingExpiry}>
                  {shouldShowCountdown ? (
                    <Countdown
                      status={[]}
                      type=""
                      isBufferTime={true}
                      bufferEndTime={bufferEndTime}
                    />
                  ) : (
                    <span>{item.expiryAt}</span>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={Styles.selfListingHeaderLeft}>
                {showContractId ? (
                  <div className={Styles.contractIdLine} title={contractId}>
                    {idLabel}{" "}
                    <span
                      className={Styles.contractValue}
                      style={{
                        color:
                          item?.isInjectionOnTop === false
                            ? "var(--secondary-color-text)"
                            : "var(--primary-color-text)",
                      }}
                    >
                      {contractId}
                    </span>
                  </div>
                ) : showContractIdPlaceholder ? (
                  <div className={Styles.contractIdLine}>
                    {idLabel} <span className={Styles.contractIdSkeleton} />
                  </div>
                ) : null}
                <div
                  className={Styles.listingNumber}
                  style={{
                    color:
                      item?.isInjectionOnTop === false
                        ? "var(--secondary-color-text)"
                        : "var(--primary-color-text)",
                  }}
                >
                  {item.name}{" "}
                  {/* <span className={`${Styles.status} ${statusClass}`}>
                    <span
                      className={`${Styles.statusDot} ${statusDotClass}`}
                    >
                      
                    </span>
                    {item.status === "HOLD"
                      ? "ON HOLD"
                      : item.status === "COMPLETED"
                        ? "ONGOING"
                        : displayStatus}
                  </span> */}
                </div>
                <div className={Styles.listingExpiry}>
                  {/* {shouldShowCountdown ? (
                  <Countdown
                    status={[]}
                    type=""
                    isBufferTime={true}
                    bufferEndTime={bufferEndTime}
                  />
                ) : (
                  <>
                    <span className="warning">Expires on</span>
                    <span>{item.expiryAt}</span>
                  </>
                )} */}
                  <span className="warning">Expires on</span>
                  <span>{item.expiryAt}</span>
                </div>
              </div>
              {/* <div
              className={` ${Styles.tandContainer} ${Styles.available_border}`}
              onClick={(e) => {
                e.stopPropagation();
                const docId = termsDocumentId || item?.termsDocumentId;
                if (onViewFile && docId) {
                  onViewFile(docId);
                }
              }}
              style={{
                cursor:
                  termsDocumentId || item?.termsDocumentId
                    ? "pointer"
                    : "default",
                opacity: termsDocumentId || item?.termsDocumentId ? 1 : 0.6,
              }}
              title={
                termsDocumentId || item?.termsDocumentId
                  ? "View Terms & Conditions"
                  : "No T&C document available"
              }
            >
              <span>T&C</span>
             
              <span
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ display: "inline-block" }}
              >
                {hovered ? (
                  <UpArrowColor
                    style={{ fontSize: "20px", width: "9px", height: "9px" }}
                  />
                ) : (
                  <UpArrow
                    style={{ fontSize: "20px", width: "9px", height: "9px" }}
                  />
                )}
              </span>
            </div> */}
              <div
                className={`display_flex_row ${Styles.tandContainer} ${Styles.available_border}`}
                onClick={handleViewDocumentClick}
                style={{
                  cursor:
                    termsDocumentId || item?.termsDocumentId
                      ? "pointer"
                      : "default",
                  opacity: termsDocumentId || item?.termsDocumentId ? 1 : 0.6,
                }}
                title={
                  termsDocumentId || item?.termsDocumentId
                    ? "View Terms & Conditions"
                    : "No T&C document available"
                }
              >
                <span>Specific T&C</span>
                <span
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  style={{ display: "inline-block" }}
                >
                  {hovered ? (
                    <UpArrowColor
                      style={{ fontSize: "20px", width: "9px", height: "9px" }}
                    />
                  ) : (
                    <UpArrow
                      style={{ fontSize: "20px", width: "9px", height: "9px" }}
                    />
                  )}
                </span>
                {/* <CallMadeIcon
                style={{
                  color: "#8C8A96",
                  fontSize: "8px",
                  marginTop: "-10px",
                }}
              /> */}
              </div>
            </>
          )}
        </div>

        {/* Content Summary */}

        {isInConnectModal ? (
          <div className={`display_flex_row ${Styles.connectSelf}`}>
            <div className={Styles.injectDrawalConnect}>
              <div className={Styles.injectConnectPart}>
                <div className="display_flex_column_gap_8">
                  <div>Min Injec. Qty</div>
                  <div>
                    {item?.minInjectQuantity}
                    (MW)
                  </div>
                </div>
                <div className="display_flex_column_gap_8">
                  <div>Max Injec. Qty</div>

                  <div>
                    {item?.maxInjectQuantity}
                    (MW)
                  </div>
                </div>
                <div
                  className="display_flex_column_gap_8"
                  style={{ width: "22%" }}
                >
                  <div>BF</div>
                  <div>{Number(item.bankingFactor).toFixed(2)} (%)</div>
                </div>
              </div>
              <div className={Styles.injectConnectPart}>
                <div className="display_flex_column_gap_8">
                  <div>Min Drawal Qty</div>
                  <div>
                    {item.minDrawalQuantity}
                    (MW)
                  </div>
                </div>
                <div className="display_flex_column_gap_8">
                  <div>Max Drawal Qty</div>

                  <div>
                    {item?.maxDrawalQuantity}
                    (MW)
                  </div>
                </div>
                <div className="display_flex_column_gap_8">
                  <div>SR</div>
                  <div>{item.settlementRate} (₹/kWh)</div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={`display_flex_row ${Styles.selfListingContentCon}`}>
            <>
              <div>
                <div>Banking Factor</div>
                <div>
                  {Number(item.bankingFactor).toFixed(2)}{" "}
                  <span style={{ color: "#8c8a96", fontSize: "10px" }}>
                    (%)
                  </span>
                </div>
              </div>
              <div>
                <div>Settlement Rate</div>
                <div>
                  {item.settlementRate}{" "}
                  <span style={{ color: "#8c8a96", fontSize: "10px" }}>
                    (₹/kWh)
                  </span>
                </div>
              </div>
            </>
          </div>
        )}

        <div
          className={`${Styles.injectionDrwalBox} ${
            isInConnectModal ? Styles.connectModalBox : ""
          }`}
        >
          <div className={Styles.drawalInjectSection}>
            <div className={Styles.injectionSection}>
              <div className={Styles.injection_header}>Injection Range</div>
              <div className={Styles.injectionDateTime}>
                <div className={`${Styles.injection_value}`}>
                  <div className={Styles.inj_date}>
                    {item.bankingSlotInjects?.[0]?.dateStartAt.replace(
                      /-/g,
                      " ",
                    )}{" "}
                    -{" "}
                    {item.bankingSlotInjects?.[0]?.dateEndAt.replace(/-/g, " ")}
                  </div>
                </div>
                <div className={Styles.inj_time}>
                  {item.bankingSlotInjects?.[0]?.slotStartAt} -{" "}
                  {transformTimeForUI(item.bankingSlotInjects?.[0]?.slotEndAt)}
                </div>
              </div>
            </div>

            <div className={Styles.drawalSection}>
              <div
                className={`${Styles.drawalHeader} ${Styles.injection_header}`}
              >
                Drawal Range
              </div>
              <div className={Styles.drawalTimeDate}>
                <div className={`${Styles.drawal_value}`}>
                  <div className={Styles.inj_date}>
                    {item.bankingSlotDrawls?.[0]?.dateStartAt.replace(
                      /-/g,
                      " ",
                    )}{" "}
                    -{" "}
                    {item.bankingSlotDrawls?.[0]?.dateEndAt.replace(/-/g, " ")}
                  </div>
                </div>
                <div className={Styles.inj_time}>
                  {item.bankingSlotDrawls?.[0]?.slotStartAt} -{" "}
                  {transformTimeForUI(item.bankingSlotDrawls?.[0]?.slotEndAt)}
                </div>
              </div>
            </div>
          </div>

          {isInConnectModal ? (
            <div
              className={Styles.viewAllButtonConnect}
              onClick={() => {
                if (typeof handleOpenIndent === "function")
                  handleOpenIndent(item);
              }}
            >
              View All Requisition
            </div>
          ) : (
            <div
              className={Styles.viewAllButton}
              onClick={() => {
                if (typeof handleOpenIndent === "function")
                  handleOpenIndent(item);
              }}
            >
              View All Requisition
            </div>
          )}
        </div>

        {/* Action Buttons */}
        {alterButton && (
          <div
            className={`${Styles.button_container} ${
              activeListingId
                ? Styles.button_container_active
                : Styles.button_container_inactive
            }`}
          >
            <div
              className={`${Styles.buttonListing} ${
                activeListingId &&
                item.status !== "ACCEPTED" &&
                item.isEditable !== false
                  ? Styles.buttonTextActive
                  : Styles.buttonTextInactive
              } ${
                item.status === "ACCEPTED" || item.isEditable === false
                  ? Styles.buttonDisabled
                  : ""
              }`}
              onClick={
                item.status === "ACCEPTED" || item.isEditable === false
                  ? undefined
                  : handleEditClick
              }
              style={{
                cursor:
                  item.status === "ACCEPTED" || item.isEditable === false
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  item.status === "ACCEPTED" || item.isEditable === false
                    ? 0.5
                    : 1,
              }}
            >
              {activeListingId && item.isEditable === false ? (
                <>
                  <Edit
                    color="inherit"
                    className={Styles.button_icon_active}
                    style={{ opacity: 0.5 }}
                  />
                  <span style={{ color: "#ffffff" }}>Edit</span>
                </>
              ) : !activeListingId ? (
                <>
                  <EditInactiveIcon
                    color="inherit"
                    className={Styles.button_icon_inactive}
                  />
                  <span style={{ color: "#A9A8B1" }}>Edit</span>
                </>
              ) : (
                <>
                  <Edit color="inherit" className={Styles.button_icon_active} />
                  <span>Edit</span>
                </>
              )}
            </div>

            {/* <div
              className={`${Styles.buttonListing} ${
                activeListingId
                  ? Styles.buttonTextActive
                  : Styles.buttonTextInactive
              }`}
              onClick={() => handleReceiveNav(item.id, item.name, item.status)}
            >
              {activeListingId ? (
                <Request className={Styles.button_icon} />
              ) : (
                <RequestInactiveIcon className={Styles.button_icon} />
              )}
              <span>Ledger</span>
            </div>

            <div
              onClick={() => !item.isEditable && handleChat()}
              className={`${Styles.buttonListing} ${
                activeListingId
                  ? Styles.buttonTextActive
                  : Styles.buttonTextInactive
              }`}
              style={{
                cursor: item.isEditable ? "no-drop" : "pointer",
                opacity: item.isEditable ? 0.5 : 1,
              }}
            >
              {activeListingId ? (
                <Chat className={Styles.button_icon} />
              ) : (
                <ChatInactiveIcon className={Styles.button_icon} />
              )}
              <span>Chat</span>
            </div> */}

            <div
              className={`${Styles.buttonListing} ${
                activeListingId
                  ? Styles.buttonTextActive
                  : Styles.buttonTextInactive
              }`}
              onClick={
                activeListingId && !downloadLoading ? handleDownload : undefined
              }
              style={{
                cursor: downloadLoading
                  ? "not-allowed"
                  : activeListingId
                    ? "pointer"
                    : "default",
                opacity: downloadLoading ? 0.6 : 1,
              }}
            >
              {downloadLoading ? (
                <span className={Styles.button_icon}>
                  <svg width="18" height="18" viewBox="0 0 50 50">
                    <circle
                      cx="25"
                      cy="25"
                      r="20"
                      fill="none"
                      stroke="white"
                      strokeWidth="4"
                      strokeDasharray="31.415, 31.415"
                      transform="rotate(72.9642 25 25)"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </svg>
                </span>
              ) : activeListingId ? (
                <Download className={Styles.button_icon} />
              ) : (
                <DownloadInactiveIcon className={Styles.button_icon} />
              )}
              <span>{downloadLoading ? "Downloading..." : "Download"}</span>
            </div>

            {process.env.REACT_APP_ENV === "qa" && (
              <div
                className={`${Styles.buttonListing} ${
                  activeListingId
                    ? Styles.buttonTextActive
                    : Styles.buttonTextInactive
                }`}
                onClick={onDuplicateClick}
              >
                {activeListingId ? (
                  <Duplicate className={Styles.button_icon} />
                ) : (
                  <DuplicateInactiveIcon className={Styles.button_icon} />
                )}
                <span>Duplicate</span>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SelfListingBox;
